export default {
  bot: 'Bot',
  campaign: 'Campaña',
  audit: 'Audiencia',
  failed: 'Fallaron',
  received: 'Recibidas',
  read: 'eídas',
  scheduled: 'Programadas',
  send_date: 'Fecha de Envío',
  processed: 'Enviadas',
};
